import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, errMsg } from "@/lib/api";

const LABEL = (f) => {
  const s = { extra: "Keep as extra detail", ignore: "Ignore column", source_patient_id: "Patient ID / MRN", dob: "Date of birth",
    patient_name: "Full name (Last, First)", address_line1: "Address line 1", address_line2: "Address line 2" }[f] || f.replace(/_/g, " ");
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export default function ColumnMapper({ preview, mapping, setMapping }) {
  const fields = [...preview.fields, "extra", "ignore"];
  const value = (c) => mapping[c.header.toLowerCase()] || c.field;
  const save = async () => {
    const m = Object.fromEntries(preview.columns.map((c) => [c.header.toLowerCase(), value(c)]));
    try { await api.put("/practice/import-mapping", { mapping: m }); toast.success("Column mapping saved for this organization"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="w-full border rounded-md p-3" data-testid="column-mapper">
      <div className="flex items-center justify-between mb-2">
        <p className="font-semibold text-sm">Column mapping ({preview.columns.length} columns)</p>
        <Button size="sm" variant="outline" onClick={save} data-testid="mapping-save-btn">Save as organization default</Button>
      </div>
      <div className="max-h-72 overflow-y-auto">
        <Table><TableHeader><TableRow><TableHead>Column in file</TableHead><TableHead>Sample values</TableHead><TableHead>Loads into</TableHead></TableRow></TableHeader>
          <TableBody>{preview.columns.map((c) => (
            <TableRow key={c.header}>
              <TableCell className="text-sm font-medium">{c.header}{c.saved && <span className="ml-1 text-[10px] text-green-700">saved</span>}</TableCell>
              <TableCell className="text-xs text-slate-500 max-w-[220px] truncate">{c.samples.join(" | ")}</TableCell>
              <TableCell>
                <select className="h-9 border rounded-md px-2 text-sm w-52" value={value(c)} aria-label={`Map ${c.header}`}
                  onChange={(e) => setMapping({ ...mapping, [c.header.toLowerCase()]: e.target.value })} data-testid={`map-${c.header.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                  {fields.map((f) => <option key={f} value={f}>{LABEL(f)}</option>)}
                </select>
              </TableCell>
            </TableRow>))}</TableBody></Table>
      </div>
    </div>
  );
}
